export default "__VITE_PUBLIC_ASSET__3d961dbb__"